<template>
  <div>
    <footer class="footer">
      <img src="../../assets/images/index/icon-buttom-zwjg.png" alt="" ondragstart="return false" />
      <h3>版权所有：四川省文学艺术界联合会</h3>
      <h3>
        <span>地址：四川省成都市红星路二段85号</span>
        <span style="margin-left: 10px">邮编：610012</span>
        <span style="margin-left: 38px"
          >四川文艺网/四川文艺报投稿邮箱：scwyw2010@163.com</span
        >
      </h3>
      <h3>
        <span>Copyright2008-2016 ARTSC.COM.CN ALL Right Resered</span>
        <span style="margin-left: 56px">蜀ICP备18012531号-1</span>
      </h3>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.footer {
  padding: 90px 300px;
  background-color: #161616;
  color: white;

  h3 {
    text-align: center;
    font-size: 14px;
    font-weight: normal;
    margin-top: 12px;
  }

  img {
    width: 48px;
    height: 60px;
    display: block;
    margin: 0 auto;
  }
}
</style>